import { keepValueUnchanged } from '../../field-viewer/shared-normalizers';
export const signatureViewer = {
    normalizeLoadedValue: keepValueUnchanged
};

//# sourceMappingURL=definition-viewer.js.map